import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'
import { AdminProgressReviewStatusRequest } from '../../contracts/review'

export const getAdminProgressReviewStatusRequest = asBuilder((): AdminProgressReviewStatusRequest => {
  return {
    reviewId: faker.number.int(),
    ongoing: faker.datatype.boolean(),
  }
})
